// JS mirror of the SCSS design tokens.
// Some Vuetify components and Vue runtime config use colors from JS
// (for example `:color`, inline styles, and chart/options objects),
// so the design system tokens also need to be exposed outside SCSS.
export const RMR_INDIGO = "#6366F1";
export const RMR_INDIGO_BG = "#EEF2FF";
export const RMR_DANGER = "#DC2626";
export const RMR_INDIGO_DARK = "#312E81";
export const RMR_ON_DARK_MUTED = "rgba(255,255,255,0.5)";
export const RMR_SURFACE_2 = "#F8FAFC";
export const RMR_BORDER_HOVER = "#E2E8F0";
export const RMR_TEXT_PRIMARY = "#0F172A";
export const RMR_TEXT_MUTED = "#64748B";
export const RMR_TEXT_SUBTLE = "#94A3B8";
export const RMR_TEXT_SECONDARY = "#475569";
export const RMR_GREEN = "#059669";
export const RMR_GREEN_BG = "#ECFDF5";
export const RMR_GREEN_DARK = "#15803D";
export const RMR_SUCCESS = "#56ca00";
export const RMR_WARNING = "#FB8C00";
export const RMR_INFO = "#1E88E5";
export const RMR_SESSIONS = "#0284C7";
export const RMR_CA = "#EA580C";
export const RMR_ORANGE = "#D97706";
export const RMR_CA_SOFT = "#FFF7ED";
export const RMR_CA_TINT = "#FED7AA";
export const RMR_CA_DARK = "#B45309";
export const RMR_SESSIONS_SOFT = "#F0F9FF";
export const RMR_SESSIONS_TINT = "#BAE6FD";
export const RMR_RPM = "#7C3AED";
export const RMR_RPM_SOFT = "#F5F3FF";
export const RMR_RPM_TINT = "#DDD6FE";
export const RMR_RED_BG = "#FEE2E2";
export const RMR_LLM_PERPLEXITY = "#7C3AED";
export const RMR_LLM_GEMINI = "#1E88E5";
export const RMR_LLM_OPENAI = "#10B981";
export const RMR_LLM_FALLBACK = "#9E9E9E";
